import Vue from 'vue'
import {
  Button,
  Select,
  Option,
  Row,
  Col,
  Form,
  FormItem,
  Dialog,
  DropdownMenu,
  Dropdown,
  Input,
  Checkbox,
  Scrollbar,
  DropdownItem,
  Tabs,
  TabPane,
  Autocomplete,
  Tooltip,
  Menu,
  MenuItem,
  Steps,
  Step,
  Popover,
  Submenu,
  Loading,
  DatePicker,
  Message,
  MessageBox,
  Table,
  TableColumn,
  Pagination,
  Link,
  Radio,
  RadioGroup,
  RadioButton,
  Slider,
  Switch,
} from 'element-ui'

Vue.use(Switch)
Vue.use(Slider)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Radio)
Vue.use(Link)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Scrollbar)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Autocomplete)
Vue.use(Tooltip)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Submenu)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Loading)
Vue.use(DatePicker)
Vue.use(Popover)
Vue.use(Dialog)
Vue.use(DropdownMenu)
const { alert, confirm } = MessageBox
Vue.prototype.$message = Message
Vue.prototype.$alert = alert
Vue.prototype.$confirm = confirm
